@if (procDef) {
  <div>
    <dl class="govuk-summary-list">
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Id</dt>
        <dd class="govuk-summary-list__value">{{procDef.id}}</dd>
      </div>
      @if (procDef.name) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key"> Name </dt>
          <dd class="govuk-summary-list__value"> {{procDef.name}} </dd>
        </div>
      }
      @if (procDef.version) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Version</dt>
          <dd class="govuk-summary-list__value"> {{procDef.version}} </dd>
        </div>
      }
      @if (procDef.description) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Description </dt>
          <dd class="govuk-summary-list__value"> {{procDef.description}} </dd>
        </div>
      }
      @if (procDef.category) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Category</dt>
          <dd class="govuk-summary-list__value"> {{procDef.category}} </dd>
        </div>
      }
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Suspended?</dt>
        <dd class="govuk-summary-list__value"> {{procDef.suspended}} </dd>
      </div>
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Start form defined?</dt>
        <dd class="govuk-summary-list__value"> {{procDef.startFormDefined}} </dd>
      </div>
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Startable by</dt>
        <dd class="govuk-summary-list__value">
          @for (starter of procDef.starters; track starter; let i = $index) {
            <span class="govuk-table__row">
              {{starter.group === undefined ? starter.user : starter.group}};
            </span>
          }
          <button class="govuk-button govuk-button-secondary" data-module="govuk-button" [routerLink]="['/proc-defs/proc-starter', procDef.id]">Add</button>
        </div>
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Deployment id</dt>
          <dd class="govuk-summary-list__value"> {{procDef.deploymentId}} </dd>
        </div>
        @if (procDef.resourceContent) {
          <div class="govuk-summary-list__row">
            <dt class="govuk-summary-list__key">Diagram</dt>
            @if (!procDef.graphicalNotationDefined) {
              <dd class="govuk-summary-list__value"> Not available</dd>
            }
          </div>
        }
        @if (procDef.graphicalNotationDefined) {
          <div class="govuk-summary-list__row">
            <dd class="" [innerHTML]="html"></dd>
          </div>
        }
        @if (procDef.resourceContent) {
          <div class="govuk-summary-list__row" style="display:none">
            <dt class="govuk-summary-list__key">XML</dt>
            <dd class="govuk-summary-list__value">
              <span class="hidden" style="display:none"> {{procDef.resourceContent.content}} </span>
            </dd>
          </div>
        }
      </dl>
      <div class="govuk-button-group">
        <button class="govuk-button" data-module="govuk-button" [routerLink]="['/proc-defs']">
          Back to list
        </button>
      </div>
    </div>
  }
